<template>
  <div class="contact-page section-wrap">
    <section class="contact-intro">
      <div>
        <p class="eyebrow">{{ t("about.eyebrow") }}</p>
        <h1 class="section-title">{{ t("about.title") }}</h1>
        <p class="section-lead">{{ t("about.lead") }}</p>
      </div>
      <img src="../assets/fotos/web/outside_logo.jpg" :alt="t('about.imageAlt')" />
    </section>

    <section class="contact-cards">
      <article>
        <h2>{{ t("about.addressTitle") }}</h2>
        <p>
          Rua da Indústria Metalúrgica, 916 B<br />
          2430-528 Marinha Grande, Portugal
        </p>
      </article>
      <article>
        <h2>{{ t("about.telephoneTitle") }}</h2>
        <p><a href="tel:+351244024482">+351 244 024 482</a></p>
      </article>
      <article>
        <h2>{{ t("about.emailTitle") }}</h2>
        <p><a href="mailto:info@jorgecastanho.pt">info@jorgecastanho.pt</a></p>
      </article>
    </section>

    <section class="map-section">
      <iframe
        :title="t('about.mapTitle')"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3067.7471083966193!2d-8.902424384392345!3d39.74533117944891!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd220c15a1a768e5%3A0x8ffebeaf59c25d07!2sJorge%20Castanho%20Lda!5e0!3m2!1sen!2spt!4v1668451207189!5m2!1sen!2spt"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </section>
  </div>
</template>

<script>
import { t } from "../i18n";

export default {
  name: "About",
  methods: {
    t,
  },
};
</script>

<style lang="scss" scoped>
.contact-page {
  padding: 2.5rem 0 4.5rem;
}

.eyebrow {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 0.75rem;
  color: var(--brand-purple);
  font-weight: 700;
}

.contact-intro {
  display: grid;
  grid-template-columns: 1fr 1.05fr;
  gap: 1.4rem;
  align-items: center;
}

.contact-intro img {
  width: 100%;
  aspect-ratio: 16 / 10;
  object-fit: cover;
  border-radius: 24px;
  border: 1px solid rgba(91, 28, 159, 0.1);
  box-shadow: 0 14px 32px rgba(15, 20, 28, 0.12);
}

.contact-intro .section-title {
  margin-top: 0.4rem;
  margin-bottom: 0.75rem;
}

.contact-cards {
  margin-top: 2rem;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.95rem;
}

.contact-cards article {
  background: #ffffff;
  border: 1px solid rgba(91, 28, 159, 0.13);
  border-radius: 20px;
  padding: 1.3rem;
  box-shadow: 0 12px 24px rgba(15, 20, 28, 0.08);
}

.contact-cards h2 {
  margin: 0;
  font-size: 1.05rem;
  color: var(--brand-purple-deep);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.contact-cards p {
  margin: 0.8rem 0 0;
  line-height: 1.7;
  color: #515b6e;
}

.contact-cards a {
  color: var(--brand-purple);
  text-decoration: none;
  font-weight: 650;
}

.map-section {
  margin-top: 1.8rem;
  border-radius: 26px;
  overflow: hidden;
  border: 1px solid rgba(91, 28, 159, 0.15);
  box-shadow: 0 16px 36px rgba(15, 20, 28, 0.12);
}

.map-section iframe {
  width: 100%;
  min-height: 460px;
  border: 0;
  display: block;
}

@media (max-width: 980px) {
  .contact-intro {
    grid-template-columns: 1fr;
  }

  .contact-cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 680px) {
  .contact-page {
    padding-top: 2rem;
  }

  .contact-cards {
    grid-template-columns: 1fr;
  }

  .map-section iframe {
    min-height: 350px;
  }
}
</style>
